var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotRegistered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 84,
    viewBox: "0 0 211 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 84,
    rx: 8,
    fill: "#7E8793"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203 84C207.418 84 211 80.4183 211 76V38.3939C211 31.4013 202.66 27.7741 197.545 32.5421L193.111 36.6749C192.253 37.4751 191.229 38.0767 190.112 38.4369L176.431 42.8491C174.404 43.5026 172.201 43.3214 170.309 42.3457L158.013 36.0058C154.86 34.3798 151.012 35.0251 148.562 37.5909L138.456 48.172C136.156 50.5806 132.604 51.312 129.539 50.0083L120.347 46.0979C117.239 44.7757 113.635 45.548 111.342 48.0277L100.803 59.4234C97.9982 62.4561 93.3458 62.8548 90.066 60.3435L80.0319 52.6605C78.2657 51.3082 76.0163 50.7523 73.8236 51.1262L59.7835 53.5204C58.3772 53.7602 57.0606 54.3717 55.9702 55.2915L42.2533 66.862C40.088 68.6885 37.1182 69.2337 34.4454 68.2954L23.0959 64.3114C21.0535 63.5945 18.8078 63.7357 16.8713 64.703L3.71537 71.2743C1.4385 72.4116 0 74.7381 0 77.2832C0 80.9928 3.00721 84 6.71679 84H203Z",
    fill: "url(#paint0_linear_1785_48)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1785_48",
    x1: 109.896,
    y1: 40.2633,
    x2: 109.926,
    y2: 84.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E72B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRegistered);
export default __webpack_public_path__ + "static/media/NotRegistered.420c50adc279a8108ade6091a6dac127.svg";
export { ForwardRef as ReactComponent };